import { ClassificationCode } from "@/types/code.types";

import { AUTHORITY_TYPE } from "../constants/authorityType.constants";
import { ALLOWED_EDITOR_ROLES_AND_CLASSIFICATION_FILL_IN_TABLE } from "../constants/editorRolesAndClassification.constants";
import { CLASSIFICATION_KEYS_CODE } from "../constants/returnRolesList.constants";

import type { AuthorityType, EditorRoleCode } from "../types/roles.types";

interface Args {
  editorRoles: EditorRoleCode[];
  authorityType: AuthorityType;
  classificationAi: ClassificationCode;
  classificationManual: ClassificationCode;
}

export class FillInTableRoleChecker {
  private editorRoles: EditorRoleCode[];

  private authorityType: AuthorityType;

  private classificationAi: ClassificationCode;

  private classificationManual: ClassificationCode;

  constructor({
    editorRoles,
    authorityType,
    classificationAi,
    classificationManual,
  }: Args) {
    this.editorRoles = editorRoles;
    this.authorityType = authorityType;
    this.classificationAi = classificationAi;
    this.classificationManual = classificationManual;
  }

  private get hasValidRoles(): boolean {
    // NOTE: Publication 타입인 경우 무조건 접근 가능하도록 설정
    if (this.classificationManual.startsWith("P")) return true;
    // NOTE: CTG 타입인 경우 무조건 접근 가능하도록 설정
    if (this.classificationManual === "ctg") return true;
    // NOTE: Regulatory Label 타입인 경우 무조건 접근 가능하도록 설정
    if (
      CLASSIFICATION_KEYS_CODE.regulatoryLabel.includes(
        this.classificationManual,
      )
    )
      return true;
    if (this.classificationManual === "patent") return true;

    if (!this.classificationManual)
      return this.editorRoles.some((role) =>
        ALLOWED_EDITOR_ROLES_AND_CLASSIFICATION_FILL_IN_TABLE[role]?.includes(
          this.classificationAi,
        ),
      );
    return this.editorRoles.some((role) =>
      ALLOWED_EDITOR_ROLES_AND_CLASSIFICATION_FILL_IN_TABLE[role]?.includes(
        this.classificationManual,
      ),
    );
  }

  private get isSuperAdmin(): boolean {
    return this.authorityType === AUTHORITY_TYPE.superAdmin;
  }

  public get canAccess(): boolean {
    return this.isSuperAdmin || this.hasValidRoles;
  }
}
